import React from 'react';

export default function ({ size = 19 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_32524_248)">
        <mask
          id="mask0_32524_248"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width={size}
          height={size}
        >
          <path
            d="M9.48451 0C9.68328 0 9.85662 0.135923 9.90514 0.328846C10.0534 0.91891 10.2488 1.49612 10.4895 2.05492C11.1185 3.51646 11.9817 4.7956 13.0776 5.89146C14.174 6.98762 15.4528 7.8508 16.9141 8.47985C17.473 8.72041 18.0503 8.91581 18.6405 9.06417C18.8334 9.11269 18.969 9.28574 18.969 9.48451C18.969 9.68328 18.8334 9.85662 18.6402 9.90514C18.0501 10.0534 17.4729 10.2488 16.9141 10.4895C15.4526 11.1185 14.1737 11.9817 13.0776 13.0776C11.9817 14.174 11.1185 15.4528 10.4895 16.9141C10.2488 17.473 10.0533 18.0503 9.90485 18.6405C9.88135 18.7342 9.82725 18.8174 9.75111 18.8769C9.67497 18.9365 9.58115 18.9689 9.48451 18.969C9.28574 18.969 9.11269 18.8334 9.06417 18.6402C8.91578 18.0501 8.72028 17.4729 8.47955 16.9141C7.8508 15.4526 6.98791 14.1737 5.89146 13.0776C4.79531 11.9817 3.51646 11.1185 2.05492 10.4895C1.4961 10.2488 0.918894 10.0533 0.328846 9.90485C0.2351 9.88142 0.151849 9.82739 0.092283 9.7513C0.0327169 9.67521 0.000241026 9.58143 0 9.4848C0 9.28603 0.135923 9.11298 0.328846 9.06446C0.918919 8.91608 1.49613 8.72058 2.05492 8.47985C3.51646 7.85109 4.7956 6.98791 5.89146 5.89175C6.98762 4.79589 7.8508 3.51675 8.47985 2.05522C8.7204 1.49638 8.9158 0.919178 9.06417 0.329138C9.08755 0.235289 9.14161 0.151937 9.21776 0.0923085C9.29391 0.0326804 9.38779 0.000192342 9.48451 0Z"
            fill="black"
          />
        </mask>
        <g mask="url(#mask0_32524_248)">
          <g filter="url(#filter0_f_32524_248)">
            <path
              d="M-1.71268 14.8306C0.479041 15.6091 2.99815 14.1496 3.91395 11.5708C4.82975 8.99238 3.79527 6.27099 1.60355 5.49258C-0.588174 4.71416 -3.10728 6.17366 -4.02337 8.7521C-4.93888 11.3308 -3.9044 14.0522 -1.71268 14.8306Z"
              fill="#FFE432"
            />
          </g>
          <g filter="url(#filter1_f_32524_248)">
            <path
              d="M8.01882 6.32753C11.0296 6.32753 13.4707 3.83269 13.4707 0.755563C13.4707 -2.32185 11.0299 -4.81641 8.01882 -4.81641C5.00776 -4.81641 2.56641 -2.32156 2.56641 0.755563C2.56641 3.83269 5.00747 6.32753 8.01882 6.32753Z"
              fill="#FC413D"
            />
          </g>
          <g filter="url(#filter2_f_32524_248)">
            <path
              d="M5.89992 24.1473C9.0431 23.9938 11.4298 20.5683 11.2307 16.4964C11.032 12.4246 8.32227 9.24808 5.17909 9.40184C2.0359 9.55559 -0.350792 12.9809 -0.15173 17.0527C0.0473314 21.1245 2.75673 24.3011 5.89992 24.1473Z"
              fill="#00B95C"
            />
          </g>
          <g filter="url(#filter3_f_32524_248)">
            <path
              d="M5.89992 24.1473C9.0431 23.9938 11.4298 20.5683 11.2307 16.4964C11.032 12.4246 8.32227 9.24808 5.17909 9.40184C2.0359 9.55559 -0.350792 12.9809 -0.15173 17.0527C0.0473314 21.1245 2.75673 24.3011 5.89992 24.1473Z"
              fill="#00B95C"
            />
          </g>
          <g filter="url(#filter4_f_32524_248)">
            <path
              d="M9.04816 21.683C11.683 20.0797 12.3884 16.4285 10.6234 13.5276C8.85845 10.6265 5.29142 9.57445 2.65627 11.1775C0.0211152 12.7811 -0.684223 16.4323 1.08073 19.3334C2.84627 22.2343 6.41301 23.2863 9.04816 21.683Z"
              fill="#00B95C"
            />
          </g>
          <g filter="url(#filter5_f_32524_248)">
            <path
              d="M19.6989 12.5683C22.6605 12.5683 25.0615 10.2562 25.0615 7.40443C25.0615 4.55239 22.6605 2.24023 19.6989 2.24023C16.7372 2.24023 14.3362 4.55239 14.3362 7.40443C14.3362 10.2565 16.7372 12.5683 19.6989 12.5683Z"
              fill="#3186FF"
            />
          </g>
          <g filter="url(#filter6_f_32524_248)">
            <path
              d="M-3.81897 11.9674C-1.09174 14.041 2.89212 13.3906 5.07946 10.514C7.2668 7.63773 6.82951 3.62464 4.10228 1.55101C1.37504 -0.522916 -2.60852 0.127468 -4.79616 3.00407C-6.98349 5.88038 -6.54591 9.89376 -3.81897 11.9674Z"
              fill="#FBBC04"
            />
          </g>
          <g filter="url(#filter7_f_32524_248)">
            <path
              d="M16.0723 -0.683598C16.9004 0.442371 15.8361 2.63117 13.6955 4.20583C11.5547 5.78049 9.14809 6.14412 8.31998 5.01845C7.49187 3.89219 8.55587 1.70309 10.6964 0.128725C12.8373 -1.44594 15.2442 -1.80957 16.072 -0.683891L16.0723 -0.683598Z"
              fill="#749BFF"
            />
          </g>
          <g filter="url(#filter8_f_32524_248)">
            <path
              d="M9.27406 4.70756C12.5847 1.63658 13.7209 -2.52121 11.8122 -4.57905C9.90339 -6.6369 5.67195 -5.8161 2.36127 -2.74512C-0.949406 0.325868 -2.0859 4.48365 -0.176836 6.5415C1.73193 8.59934 5.96338 7.77854 9.27406 4.70756Z"
              fill="#FC413D"
            />
          </g>
        </g>
        <path
          d="M9.48451 0C9.68328 0 9.85662 0.135923 9.90514 0.328846C10.0534 0.91891 10.2488 1.49612 10.4895 2.05492C11.1185 3.51646 11.9817 4.7956 13.0776 5.89146C14.174 6.98762 15.4528 7.8508 16.9141 8.47985C17.473 8.72041 18.0503 8.91581 18.6405 9.06417C18.8334 9.11269 18.969 9.28574 18.969 9.48451C18.969 9.68328 18.8334 9.85662 18.6402 9.90514C18.0501 10.0534 17.4729 10.2488 16.9141 10.4895C15.4526 11.1185 14.1737 11.9817 13.0776 13.0776C11.9817 14.174 11.1185 15.4528 10.4895 16.9141C10.2488 17.473 10.0533 18.0503 9.90485 18.6405C9.88135 18.7342 9.82725 18.8174 9.75111 18.8769C9.67497 18.9365 9.58115 18.9689 9.48451 18.969C9.28574 18.969 9.11269 18.8334 9.06417 18.6402C8.91578 18.0501 8.72028 17.4729 8.47955 16.9141C7.8508 15.4526 6.98791 14.1737 5.89146 13.0776C4.79531 11.9817 3.51646 11.1185 2.05492 10.4895C1.4961 10.2488 0.918894 10.0533 0.328846 9.90485C0.2351 9.88142 0.151849 9.82739 0.092283 9.7513C0.0327169 9.67521 0.000241026 9.58143 0 9.4848C0 9.28603 0.135923 9.11298 0.328846 9.06446C0.918919 8.91608 1.49613 8.72058 2.05492 8.47985C3.51646 7.85109 4.7956 6.98791 5.89146 5.89175C6.98762 4.79589 7.8508 3.51675 8.47985 2.05522C8.7204 1.49638 8.9158 0.919178 9.06417 0.329138C9.08755 0.235289 9.14161 0.151937 9.21776 0.0923085C9.29391 0.0326804 9.38779 0.000192342 9.48451 0Z"
          fill="url(#paint0_radial_32524_248)"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_32524_248"
          x="-5.79497"
          y="3.84505"
          width="11.4807"
          height="12.6322"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="0.719077" result="effect1_foregroundBlur_32524_248" />
        </filter>
        <filter
          id="filter1_f_32524_248"
          x="-4.38526"
          y="-11.7681"
          width="24.8076"
          height="25.0479"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="3.47583" result="effect1_foregroundBlur_32524_248" />
        </filter>
        <filter
          id="filter2_f_32524_248"
          x="-6.07321"
          y="3.48661"
          width="23.2254"
          height="26.5756"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="2.95494" result="effect1_foregroundBlur_32524_248" />
        </filter>
        <filter
          id="filter3_f_32524_248"
          x="-6.07321"
          y="3.48661"
          width="23.2254"
          height="26.5756"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="2.95494" result="effect1_foregroundBlur_32524_248" />
        </filter>
        <filter
          id="filter4_f_32524_248"
          x="-5.80111"
          y="4.51786"
          width="23.3063"
          height="23.8256"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="2.95494" result="effect1_foregroundBlur_32524_248" />
        </filter>
        <filter
          id="filter5_f_32524_248"
          x="8.72037"
          y="-3.37558"
          width="21.957"
          height="21.5598"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="2.80791" result="effect1_foregroundBlur_32524_248" />
        </filter>
        <filter
          id="filter6_f_32524_248"
          x="-11.2781"
          y="-4.75177"
          width="22.8397"
          height="23.0211"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="2.54483" result="effect1_foregroundBlur_32524_248" />
        </filter>
        <filter
          id="filter7_f_32524_248"
          x="3.97177"
          y="-5.40506"
          width="16.4487"
          height="15.1441"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="2.03358" result="effect1_foregroundBlur_32524_248" />
        </filter>
        <filter
          id="filter8_f_32524_248"
          x="-4.53835"
          y="-9.14809"
          width="20.712"
          height="20.2591"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="1.7176" result="effect1_foregroundBlur_32524_248" />
        </filter>
        <radialGradient
          id="paint0_radial_32524_248"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.6577 7.58761) rotate(135) scale(9.12092)"
        >
          <stop stopColor="#B96BFF" />
          <stop offset="1" stopColor="#F6A6FF" />
        </radialGradient>
        <clipPath id="clip0_32524_248">
          <rect width="19" height="19" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
